import React from "react"
import classes from "./GearSlot.module.css"
import Select from "react-select"
import { default_single_style, generate_abilities, generate_drinks } from "../../Utils"
import { useTranslation } from "react-i18next"

const GearSlot = props => {
    const { t } = useTranslation()

    const abilities = generate_abilities(t)
    const drinks = generate_drinks(t)

    const centerStyle = default_single_style()

    return (
        <div className={classes.SettingsContent}>
            <p>
                <strong>
                    {t("misc:Common.Slot")} {props.idx}:
                </strong>
            </p>
            <Select
                value={props.currentSlot}
                onChange={e => props.changeSlot(e, props.idx)}
                options={abilities}
                styles={centerStyle}
                defaultValue={abilities[0]}
                formatOptionLabel={elem => {
                    const url = `https://leanny.github.io/splat3/images/skill/${elem.value}.png`
                    return (
                        <>
                            {elem.value !== "None" ? (
                                <img src={url} width="32" alt={elem.label} className={classes.Ability} />
                            ) : (
                                ""
                            )}
                            <span className={classes.Gap}> {elem.label}</span>
                        </>
                    )
                }}
            />
            <p>
                <strong>
                    {t("translation:LayoutMsg.Lobby_Shop_00.T_Drink_00")} {props.idx}:
                </strong>
            </p>
            <Select
                value={props.currentDrink}
                onChange={e => props.changeDrink(e, props.idx)}
                options={drinks}
                defaultValue={drinks[0]}
                styles={centerStyle}
                formatOptionLabel={elem => {
                    const url = `https://leanny.github.io/splat3/images/skill/${elem.value}.png`
                    return (
                        <>
                            {elem.value !== "None" ? (
                                <img src={url} width="32" alt={elem.label} className={classes.Ability} />
                            ) : (
                                ""
                            )}
                            <span className={classes.Gap}>{elem.label}</span>
                        </>
                    )
                }}
            />
        </div>
    )
}

export default GearSlot
